import { AppRoleAttributeType } from "@/api-schema-enums";
import i18next from "i18next";

export function mapAttributeValueToName(value: AppRoleAttributeType | string): string {
  const attributeMap = {
    Branch: i18next.t("common:Branch"),
    Company: i18next.t("common:Company"),
    CompanyGroup: i18next.t("masterdata:CompanyGroup"),
  } as const satisfies Record<AppRoleAttributeType, string>;

  if (Object.hasOwn(attributeMap, value)) {
    return attributeMap[value as AppRoleAttributeType];
  }
  return value;
}
